export default __webpack_public_path__ + "static/media/lesnik_winter_b_06.df6b31ec.svg";